import React from 'react'
import { SprintSpecIcon } from './SprintSpecIcon'

interface Props {
  className?: string
  size?: 'medium' | 'large'
}

const sizing = {
  medium: {
    iconSize: 'h-8 w-8',
    textSize: 'text-xl'
  },
  large: {
    iconSize: 'h-10 w-10',
    textSize: 'text-2xl'
  }
}

export const SprintSpecLogo: React.FC<Props> = ({ className, size = 'medium' }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <SprintSpecIcon className={`text-primary ${sizing[size].iconSize}`} />
      <span className={`hidden sm:flex font-semibold text-gray-800 ${sizing[size].textSize}`}>SprintSpec</span>
    </div>
  )
}
